<div class="construction-site-list-root" *ngIf="subjects.length > 0">
  <div class="header row no-margins">
    <div class="col-md-4 d-none d-md-block d-lg-block d-xl-block">Intitulé du sujet</div>
    <div class="col-md-3 d-none d-md-block d-lg-block d-xl-block">Actions prévues</div>
    <div class="col-md-2 d-none d-md-block d-lg-block d-xl-block">Affectation</div>
    <div class="due col-md-3">
      <div dropdown class="dropdown" [insideClick]="true">
        <div dropdownToggle data-toggle="dropdown">
          Échéances
          <img src="/assets/images/due.svg" />
        </div>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li role="presentation" class="dropdown-item" *ngFor="let state of possibleStates">
            <span class="label">{{ state.label }}</span>
            <label class="myCheckbox">
              <input
                class="checkbox"
                #echeanceInput
                [id]="state.name"
                type="checkbox"
                [name]="state.name"
                [value]="state.name"
                [checked]="true"
                (change)="checkboxEcheanceClicked()"
              />
              <span></span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="content-container" *ngFor="let subject of filteredSubjects">
    <div class="content row no-margins" [ngClass]="{ resolved: subject.dates.resolution }">
      <div class="title-container col-md-4">
        <div class="subject-icon-container">
          <img
            class="subject-icon"
            [src]="
              subject.dates.resolution
                ? '/assets/images/checkmark_circle.svg'
                : '/assets/images/hourglass_circle.svg'
            "
          />
          <span class="status">{{
            subject.dates.resolution
              ? 'Activité résolue'
              : subject.dates.due
              ? 'En cours de résolution'
              : 'En cours de validation'
          }}</span>
        </div>
        <span class="subject-title">{{ subject.title }}</span>
      </div>
      <div class="action col-md-3">
        <div class="title">Action prévue</div>
        <div>{{ subject.action || 'Aucune action prévue' }}</div>
      </div>
      <div class="affectation col-md-2 order-12 order-md-7">
        <ng-container *ngIf="subject._related.users[0] !== null">
          <div class="affectation-content">
            <div class="images" *ngIf="subject._related.users.length > 1">
              <div class="showroom-image lw-rounded">
                <img [src]="subject._related.users[0]?.avatar" />
                <p>{{ subject._related.users[0]?.last_name }}</p>
                <!--
                <div
                  class="image"
                  [ngStyle]="{
                    'background-image': 'url(' + subject.concerned_users[0].avatar + ')'
                  }"
                  [title]="subject.concerned_users[0].name"
                ></div>
                -->
              </div>
              <div class="showroom-image lw-rounded">
                <img [src]="subject._related.users[1]?.avatar" />
                <p>{{ subject._related.users[1]?.last_name }}</p>
                <!--
                <div
                  class="image"
                  [ngStyle]="{
                    'background-image': 'url(' + subject.concerned_users[1].avatar + ')'
                  }"
                  [title]="subject.concerned_users[1].name"
                ></div>
                -->
              </div>
            </div>

            <div *ngIf="subject._related.users.length === 1" class="showroom-image lw-rounded">
              <img [src]="subject._related.users[0]?.avatar" />
              <p>{{ subject._related.users[0]?.last_name }}</p>
              <!--
              <div
                class="image"
                [ngStyle]="{
                  'background-image': 'url(' + subject.concerned_users[0].avatar + ')'
                }"
                [title]="subject.concerned_users[0].name"
              ></div> -->
            </div>

            <div class="affectation-text" *ngIf="subject._related.users.length >= 1">
              <p class="name">
                {{ subject._related.users[1]?.last_name }}
                {{ subject._related.users[1] ? '& ' + subject._related.users[1]?.last_name : '' }}
              </p>
              <p class="job">
                {{ getUserRole(subject._related.users[1]) }}
                {{ subject._related.users[1] ? '& ' + getUserRole(subject._related.users[1]) : '' }}
              </p>
            </div>
          </div>

        </ng-container>

      </div>
      <div class="due row col-md-3 order-7 order-md-12">
        <div class="col-12 date-md">
          <div class="title">Date d'échéance</div>
          <div class="text-container">
            <p>
              {{ subject.dates.due ? 'Activité prévue le' : 'Activité en cours de validation' }}
            </p>
            <p class="text">
              {{ (subject.dates.due | date: 'dd/MM/yyyy') || '' }}
            </p>
          </div>
        </div>

        <div class="date">
          <span [ngClass]="{ bold: subject.dates.resolution }">{{
            subject.dates.resolution
              ? 'Résolu'
              : subject.dates.due
              ? 'Prévue'
              : 'En cours de validation'
          }}</span>
          {{ (subject.dates.due | date: 'dd/MM/yyyy') || '' }}
        </div>
      </div>
    </div>
    <div class="separator"></div>
  </div>
</div>

<div class="empty" *ngIf="subjects.length === 0">
  Aucun sujet ouvert pour le moment
</div>
